const supportedLocales = new Set(['en', 'es', 'pt']);

export const normalizeLocale = locale => {
    const language = String(locale ?? '')
        .trim()
        .toLowerCase()
        .split(/[-_]/)[0];

    return supportedLocales.has(language) ? language : 'pt';
};
